"use client";

import * as React from "react";
import { formatWei } from "../../../../lib/format";
import { getChainBadgeUrl } from "../../../wallet-info/constants";
import { formatUsd } from "../../model/sendFormat";
import type { SendFlow } from "../../model/useSendFlow";
import type { SendAsset } from "../../types";
import { SearchIcon } from "../icons";

export function SendTokenSelect({ flow }: { flow: SendFlow }) {
  const [query, setQuery] = React.useState("");
  const q = query.trim().toLowerCase();
  const list = React.useMemo<SendAsset[]>(() => {
    if (!q) return flow.tokens;
    return flow.tokens.filter(
      (t) =>
        t.symbol.toLowerCase().includes(q) ||
        t.name.toLowerCase().includes(q),
    );
  }, [flow.tokens, q]);

  return (
    <div className="sf-body sf-token-select">
      <div className="sf-search">
        <SearchIcon size={20} />
        <input
          className="sf-search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search Tokens"
          autoComplete="off"
          spellCheck={false}
          aria-label="Search tokens"
        />
      </div>

      <div className="sf-token-list">
        {list.map((t) => {
          const key = `${t.chainId}:${t.address.toLowerCase()}`;
          const badge = getChainBadgeUrl(flow.resolvedEnv, t.chainId);
          const price = flow.getTokenPriceUsd?.(t);
          return (
            <button
              key={key}
              type="button"
              className="sf-token-row"
              onClick={() => flow.selectToken(t)}
              data-track="token_item"
              data-track-id={t.symbol}
            >
              <span className="sf-token-left">
                <span className="sf-token-icon-wrap">
                  <img
                    className="sf-token-icon"
                    src={t.icon_url}
                    alt=""
                    width={40}
                    height={40}
                    loading="lazy"
                    draggable={false}
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://contents.crosstoken.io/wallet/token/images/FT.png";
                    }}
                  />
                  {badge && (
                    <img
                      className="sf-token-chain-badge"
                      src={badge}
                      alt=""
                      aria-hidden
                      width={16}
                      height={16}
                      loading="lazy"
                      draggable={false}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  )}
                </span>
                <span className="sf-token-name">{t.symbol}</span>
              </span>
              <span className="sf-token-right">
                <span className="sf-token-balance">
                  {formatWei(t.quantity.numeric, t.quantity.decimals)}
                </span>
                {price !== undefined && (
                  <span className="sf-token-price">{formatUsd(price)}</span>
                )}
              </span>
            </button>
          );
        })}
        {list.length === 0 && <div className="sf-empty">No tokens found</div>}
      </div>
    </div>
  );
}
